export function IconOrientFlip({ stroke = "#c9c4ff", size = 12 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M4 12a8 8 0 0 1 14.5-4.6" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M18.5 3v4.4h-4.4" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20 12a8 8 0 0 1-14.5 4.6" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" />
      <path d="M5.5 21v-4.4h4.4" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconUndo({ stroke = "#c7cdec" }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M9 14l-4-4 4-4" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 10h9a5 5 0 0 1 0 10h-2" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function IconReset({ stroke = "#c7cdec" }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M4 4v6h6M20 20v-6h-6" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.5 15a8 8 0 1 0 1-9.5" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function IconStart({ stroke = "#ffffff" }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M8 5v14l11-7L8 5z" fill={stroke} stroke={stroke} strokeWidth="1.2" strokeLinejoin="round" />
    </svg>
  );
}

export function IconSwapArrows({ stroke = "#c7cdec", size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M7 16l-4-4 4-4M17 8l4 4-4 4" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 12h10M21 12H11" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconPersonSmall({ stroke = "#fff", size = 12 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="8" r="3.5" stroke={stroke} strokeWidth="2" />
      <path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconPause({ stroke = "#f2a93b" }) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="6" y="5" width="4" height="14" rx="1" fill={stroke} />
      <rect x="14" y="5" width="4" height="14" rx="1" fill={stroke} />
    </svg>
  );
}

export function IconPlay({ stroke = "#f2a93b" }) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M8 5.5v13l11-6.5-11-6.5z" fill={stroke} />
    </svg>
  );
}

/** Elegant tennis ball (fuzzy seams). */
export function IconTennisBall({ size = 12, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="8.5" stroke={color} strokeWidth="1.65" />
      <path
        d="M5.4 9.1c2.9 1.35 4.7 3.55 5.45 6.55"
        stroke={color}
        strokeWidth="1.45"
        strokeLinecap="round"
      />
      <path
        d="M18.6 14.9c-2.9-1.35-4.7-3.55-5.45-6.55"
        stroke={color}
        strokeWidth="1.45"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Pickleball — perforated plastic ball. */
export function IconPickleball({ size = 12, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="8.5" stroke={color} strokeWidth="1.65" />
      <circle cx="12" cy="8.2" r="1.15" fill={color} />
      <circle cx="8.35" cy="10.35" r="1.15" fill={color} />
      <circle cx="15.65" cy="10.35" r="1.15" fill={color} />
      <circle cx="9.45" cy="14.55" r="1.15" fill={color} />
      <circle cx="14.55" cy="14.55" r="1.15" fill={color} />
      <circle cx="12" cy="12.15" r="1.05" fill={color} opacity="0.9" />
    </svg>
  );
}

/** Badminton racquet — oval head + throat + grip (serve marker). */
export function IconRacquet({ size = 12, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <ellipse
        cx="10.2"
        cy="9.1"
        rx="6.1"
        ry="6.6"
        stroke={color}
        strokeWidth="1.55"
      />
      <path
        d="M7.2 6.4c1.9 1.1 3.5 2.8 4.4 4.9M13.2 6.6c-1.1 1.9-1.4 4-1.1 6.1"
        stroke={color}
        strokeWidth="1.15"
        strokeLinecap="round"
        opacity="0.85"
      />
      <path
        d="M14.4 14.1l4.6 6.1"
        stroke={color}
        strokeWidth="2.05"
        strokeLinecap="round"
      />
      <path
        d="M16.05 16.35l1.55-1.15"
        stroke={color}
        strokeWidth="1.35"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Badminton shuttlecock — skirt + cork. */
export function IconShuttlecock({ size = 12, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M12 4.2c1.1 0 2 .7 2.2 1.7l.9 4.1c.15.7-.2 1.4-.85 1.7L12 12.8l-2.25-1.1c-.65-.3-1-.95-.85-1.7l.9-4.1C10 4.9 10.9 4.2 12 4.2z"
        stroke={color}
        strokeWidth="1.45"
        strokeLinejoin="round"
      />
      <path d="M10.2 6.2h3.6M9.8 8.2h4.4M9.6 10h4.8" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
      <ellipse cx="12" cy="16.2" rx="3.2" ry="3.6" stroke={color} strokeWidth="1.55" />
      <path d="M12 12.6v2.2" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

/** Table tennis paddle — handle + face. */
export function IconPaddle({ size = 12, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <ellipse
        cx="11.2"
        cy="9.4"
        rx="6.4"
        ry="6.1"
        stroke={color}
        strokeWidth="1.55"
      />
      <path
        d="M14.6 14.2l4.2 5.6"
        stroke={color}
        strokeWidth="2.1"
        strokeLinecap="round"
      />
      <circle cx="9.6" cy="8.6" r="1.35" fill={color} opacity="0.85" />
    </svg>
  );
}

/** @deprecated use IconTennisBall / IconPickleball */
export function IconServeBall(props) {
  return <IconTennisBall {...props} />;
}
